/**
 * This code is created for Featured product feature by acowebs
 */

/**====================== Do not delete ========================= */

document.addEventListener('DOMContentLoaded', async () => {
    console.log("aco code loaded")
  if (!window.location.href.includes('pages/bfwp-shop')) return;

  const wrappers = document.querySelectorAll('#product_form_15082114482555 .aco_custom_wrapper');

  if (!wrappers.length) return;

  for (const wrapper of wrappers) {
    const form = wrapper.closest('form');

    if (!form) continue;

    const productInput = form.querySelector('input[name="product-id"]');
    const variantInput = form.querySelector('input[name="id"]');

    const productID = productInput ? productInput.value : null;
    const variantID = variantInput ? variantInput.value : null;

    if (!productID || !variantID) continue;

    if (
      window.aco_product_meta &&
      [...window.aco_product_meta.product_with_price,
       ...window.aco_product_meta.product_without_price
      ].includes(Number(productID))
    ) {
      try {
        const apiUrl = `https://scpa.acowebscdn.com/api-public/front/get-form/${productID}?shop=${window.Shopify.shop}&variant=${variantID}&languageCode=null&version=${window.aco_apiVersion}&currency=null&country=null`;

        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error('API failed');

        const data = await response.json();
        window.wcpaInit(wrapper, data.data, Math.floor(Math.random() * 10), true, undefined, wrapper);

      } catch (err) {
        console.error('Failed to fetch form data:', err);
      }
    }
  }
});

